import { type ComponentPropsWithoutRef, type ReactNode, useState } from 'react';
import { Select as _Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/ui';
import { cn } from '@/utils/tailwind.util';
export type SelectProps<T extends string = string> = Omit<ComponentPropsWithoutRef<typeof _Select>, 'open' | 'onOpenChange' | 'onValueChange'> & {
  options: {
    label: ReactNode;
    value: T;
  }[];
  isError?: boolean;
  enabledOpen?: boolean;
  onOpenAttempt?: (open: boolean) => void;
  placeHolder?: string;
  className?: string;
  onValueChange: (value: T) => void;
};
export const Select = <T extends string,>(_props: SelectProps<T>) => {
  const {
    placeHolder,
    ...props
  } = _props;
  const [open, setOpen] = useState(props.defaultOpen || false);
  return <_Select {...props} open={open} onOpenChange={_open => setOpen(_open)} onValueChange={v => props.onValueChange(v as T)} data-sentry-element="_Select" data-sentry-component="Select" data-sentry-source-file="select.tsx">
      <SelectTrigger open={open} className={cn('w-full rounded-sm', !!props.isError && 'border-red-300', props.className)} data-sentry-element="SelectTrigger" data-sentry-source-file="select.tsx">
        <SelectValue placeholder={placeHolder} data-sentry-element="SelectValue" data-sentry-source-file="select.tsx" />
      </SelectTrigger>
      <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="select.tsx">
        {props.options.map(option => <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>)}
      </SelectContent>
    </_Select>;
};